// This file makes it possible to bundle node-logger for the browser
// without webpack crashing. No logs will be outputted in the browser.
module.exports = {
  log: () => {},
  error: () => {},
  warn: () => {},
  info: () => {},
  debug: () => {},
  verbose: () => {},
  silly: () => {},
};
